import React from "react";

export const AccentureIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 328.04 360"
      width="28"
      height="30"
    >
      <polygon
        fill="rgba(255,255,255,0.7)"
        points="0,360 328.04,226.9994 328.04,133.0009 0,266.0014"
      />
      <polygon
        fill="#FFFFFF"
        points="0,0 0,93.9986 328.04,226.9993 328.04,133.0009"
      />
    </svg>
  );
};

export default AccentureIcon;
